<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
    name: 'App',
    data() {
        return {
            screenWidth: document.body.clientWidth,
        }
    },
    created() {
        window.screenWidth = document.body.clientWidth;
        this.screenWidth = window.screenWidth;
        if(this.screenWidth < 694) {
            this.$router.replace('/mobile_index').catch(err => err);
        }else{
            this.$router.replace('/pc_index').catch(err => err);
        }
        // if (this._isMobile()) {
        //     this.$router.replace('/mobile_index').catch(err => err);
        // }else{
        //     this.$router.replace('/pc_index').catch(err => err);
        // }
    },
    mounted() {
        const that = this;
        window.onresize = () => {
            return (() => {
                window.screenWidth = document.body.clientWidth;
                that.screenWidth = window.screenWidth;
                if(that.screenWidth < 694) {
                    this.$router.replace('/mobile_index').catch(err => err);
                }else{
                    this.$router.replace('/pc_index').catch(err => err);
                }
            })()
        }
    },
    methods: {
        _isMobile() {
            let flag = navigator.userAgent.match(/(phone|pod|iPhone|iPod|iPad|pad|Mobile|ios|Android|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
            sessionStorage.setItem('_isMobile',flag);
            return flag;
        }
    }
}
</script>

<style>
/* 隐藏滚动条 */
html::-webkit-scrollbar {
	display: none;
}
html {
	scrollbar-width: none;
}
html {
	-ms-overflow-style:none;
}
body{
    margin: 0;
}
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
}
button {
    margin: 0;
    padding: 0;
    outline: none;
    border-radius: 0;
    background-color: transparent;
    line-height: inherit;
    width: max-content;
}
button:after {
    border: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue